// extracted by mini-css-extract-plugin
export default {"countdown":"CountDown_countdown__bDZSE","value":"CountDown_value__nG2VF","label":"CountDown_label__P67eI","box":"CountDown_box__BNccJ"};